
<div ngbDropdown (openChange)="openChange($event)">

    <div ngbDropdownToggle class="assignees">
                    
        <div class="assignee" *ngFor="let assignee of selected" [title]="assignee.fullname + ' - ' + assignee.email">
            <img [src]="assignee.photo" [alt]="assignee.fullname"  />
            <span *ngIf="show_label">{{ assignee.fullname }}</span>
        </div>

        <div class="assignee" *ngIf="!selected || selected?.length == 0">
            <span>No Assignee</span>
        </div>
        
        <span class="arrow">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <polygon id="Shape" points="0 0 24 0 24 24 0 24"/>
                    <path d="M6.70710678,15.7071068 C6.31658249,16.0976311 5.68341751,16.0976311 5.29289322,15.7071068 C4.90236893,15.3165825 4.90236893,14.6834175 5.29289322,14.2928932 L11.2928932,8.29289322 C11.6714722,7.91431428 12.2810586,7.90106866 12.6757246,8.26284586 L18.6757246,13.7628459 C19.0828436,14.1360383 19.1103465,14.7686056 18.7371541,15.1757246 C18.3639617,15.5828436 17.7313944,15.6103465 17.3242754,15.2371541 L12.0300757,10.3841378 L6.70710678,15.7071068 Z" id="Path-94" fill="#000000" fill-rule="nonzero" transform="translate(12.000003, 11.999999) rotate(-180.000000) translate(-12.000003, -11.999999) "/>
                </g>
            </svg>
        </span>  
    
    </div>

    <div ngbDropdownMenu aria-labelledby="agent-list" class="agent-list">
        
        <form [formGroup]="checkboxGroup">
            <span *ngIf="subtitle">{{ subtitle }}</span>
            <input type="input" formControlName="search" class="form-control search" placeholder="Search..." />
            <div class="tag" *ngFor="let agent of filtered_agents">
                <label class="kt-checkbox kt-checkbox--solid" *ngIf="multiple">
                    
                    <input type="checkbox" name="myValues" formArrayName="myValues"  [value]="agent.id" 
                                            (change)="onCheckboxChange($event)"
                                            [checked]="is_selected(agent.id)" /> 

                    <img [src]="agent.photo" />
                    <!--
                        <div [ngClass]="{'available' : (agent.available), 'away': !(agent.available) }" class="active-status"></div>
                    -->
                    {{agent.fullname}}
                    <span></span>
                </label>

                <label *ngIf="!multiple" (click)="onSingleSelect(agent.id)" [class.single]="!multiple" [class.selected]="is_selected(agent.id)" ngbDropdownItem>
                    <img [src]="agent.photo" />
                    <!--
                        <div [ngClass]="{'available' : (agent.available), 'away': !(agent.available) }" class="active-status"></div>
                    -->
                    <span>{{agent.fullname}}</span>
                </label>
            </div>
        </form>
        <p *ngIf="debug">{{ checkboxGroup.value | json }}</p>
    </div> 

</div>

